import React from 'react'

import { useBrandAccountId } from '../useBrandAccountId'

export const useDocumentReportsInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () =>
      ['DocumentReportListPage_DocumentReports', { brandAccountId }] as const,
    [brandAccountId],
  )
}
